import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { BaasActionButton } from '../../../../baas-action-button/baas-action-button';
import { BaasActionButtonOptions } from '../../../../baas-action-button/baas-action-button.types';

@Component({
    selector: 'baas-layout-menu-operations',
    templateUrl: './baas-layout-menu-operations.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [BaasActionButton],
    host: { class: 'bar-layout-menu-operations' }
})
export class BaasLayoutMenuOperationsComponent {
    readonly items = input<BaasActionButtonOptions[]>(undefined);

    readonly effectiveItems = computed(() => {
        const transformActions = (actions: BaasActionButtonOptions[]) => {
            return actions.map((a) => {
                a.variant = 'default';
                return a;
            });
        };
        return this.items() ? transformActions(this.items()) : [];
    });
}
